module.exports = __webpack_public_path__ + "img/teilen-box.af3ffa7d.svg";